var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radio"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "radio",
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "dot",
    x: 7,
    y: 7,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#722282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.fa10d824552825bb779dd9cf7883c6ed.svg";
export { ForwardRef as ReactComponent };